/**
 * @fileoverview gRPC-Web generated client stub for com.mu.geologic.proto
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

import * as grpcWeb from 'grpc-web';

import { GeoDistanceRequest, GeoDistanceResponse, GeocodePositionRequest, GeocodeRequest, GeocodeResponse } from './geologic_pb';

export class GeologicServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string };
  options_: null | { [index: string]: string };

  constructor(hostname: string, credentials: null | { [index: string]: string }, options: null | { [index: string]: string }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGeocode = new grpcWeb.AbstractClientBase.MethodInfo(
    GeocodeResponse,
    (request: GeocodeRequest) => {
      return request.serializeBinary();
    },
    GeocodeResponse.deserializeBinary
  );

  geocode(request: GeocodeRequest, metadata: grpcWeb.Metadata | null, callback: (err: grpcWeb.Error, response: GeocodeResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.geologic.proto.GeologicService/Geocode',
      request,
      metadata || {},
      this.methodInfoGeocode,
      callback
    );
  }

  methodInfoReverseGeocode = new grpcWeb.AbstractClientBase.MethodInfo(
    GeocodeResponse,
    (request: GeocodePositionRequest) => {
      return request.serializeBinary();
    },
    GeocodeResponse.deserializeBinary
  );

  reverseGeocode(
    request: GeocodePositionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GeocodeResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.geologic.proto.GeologicService/ReverseGeocode',
      request,
      metadata || {},
      this.methodInfoReverseGeocode,
      callback
    );
  }

  methodInfoDistanceGeolocation = new grpcWeb.AbstractClientBase.MethodInfo(
    GeoDistanceResponse,
    (request: GeoDistanceRequest) => {
      return request.serializeBinary();
    },
    GeoDistanceResponse.deserializeBinary
  );

  distanceGeolocation(
    request: GeoDistanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GeoDistanceResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.geologic.proto.GeologicService/DistanceGeolocation',
      request,
      metadata || {},
      this.methodInfoDistanceGeolocation,
      callback
    );
  }
}
